import { TypedDocumentNode, gql } from '@apollo/client';

import { requestSo5NoCardDraftableAppearanceInput } from '@sorare/core/src/__generated__/globalTypes';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import {
  RequestSo5NoCardDraftableAppearanceMutation,
  RequestSo5NoCardDraftableAppearanceMutationVariables,
} from './__generated__/useRequestNoCardDraftableAppearance.graphql';

const REQUEST_DRAFTABLE_APPEARANCE_MUTATION = gql`
  mutation RequestSo5NoCardDraftableAppearanceMutation(
    $input: requestSo5NoCardDraftableAppearanceInput!
  ) {
    requestSo5NoCardDraftableAppearance(input: $input) {
      draftableAppearance {
        id
        player {
          ... on AnyPlayerInterface {
            slug
            displayName
          }
        }
        team: anyTeam {
          slug
          name
        }
        season {
          id
          startYear
        }
        bonus
        positions
      }
      eligibleSlotIndex
      errors {
        message
      }
    }
  }
` as TypedDocumentNode<
  RequestSo5NoCardDraftableAppearanceMutation,
  RequestSo5NoCardDraftableAppearanceMutationVariables
>;

export const useRequestNoCardDraftableAppearance = () => {
  const [mutate] = useMutation(REQUEST_DRAFTABLE_APPEARANCE_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return async (input: requestSo5NoCardDraftableAppearanceInput) =>
    mutate({ variables: { input } });
};
